/**
 * OpeningsOverlay — renders door/window/cutout marks on the 2D plan view
 * along each wall, with a kind icon label. Top-down projection.
 */
export default function OpeningsOverlay({
  openings, L, W, scale, padding, viewW, viewH,
}) {
  if (!openings?.length) return null;
  const toSvgX = (xInches) => padding + xInches * scale;
  const toSvgY = (yInches) => viewH - padding - yInches * scale;
  const kindColor = { door: "#FFA500", window: "#9bd9ff", cutout: "#94a3b8" };
  return (
    <g data-testid="plan-openings">
      {openings.map((op, i) => {
        const wall = (op.wall || "back").toLowerCase();
        const w = op.w_in || 36;
        const x = op.x_in || 0;
        const color = kindColor[op.kind] || "#FFA500";
        let x1, y1, x2, y2, lx, ly, anchor = "middle";
        // x_in runs along the wall left→right when facing INTO the room.
        if (wall === "back") {
          x1 = toSvgX(x); x2 = toSvgX(x + w);
          y1 = y2 = padding;
          lx = (x1 + x2) / 2; ly = padding - 24;
        } else if (wall === "front") {
          x1 = toSvgX(x); x2 = toSvgX(x + w);
          y1 = y2 = viewH - padding;
          lx = (x1 + x2) / 2; ly = viewH - padding + 30;
        } else if (wall === "left") {
          y1 = toSvgY(x); y2 = toSvgY(x + w);
          x1 = x2 = padding;
          lx = padding - 12; ly = (y1 + y2) / 2; anchor = "end";
        } else { // right
          y1 = toSvgY(x); y2 = toSvgY(x + w);
          x1 = x2 = viewW - padding;
          lx = viewW - padding + 12; ly = (y1 + y2) / 2; anchor = "start";
        }
        return (
          <g key={`op-${i}`} data-testid={`plan-opening-${op.id || i}`}>
            <line x1={x1} y1={y1} x2={x2} y2={y2} stroke={color}
                  strokeWidth="6" strokeLinecap="round" opacity="0.95" />
            <line x1={x1} y1={y1} x2={x2} y2={y2} stroke="#0A0C10"
                  strokeWidth="2" strokeDasharray="2 3" />
            <text x={lx} y={ly} fill={color}
                  fontFamily="JetBrains Mono" fontSize="9"
                  textAnchor={anchor} fontWeight="700">
              {(op.kind || "door").toUpperCase()} {op.w_in || 36}&quot;×{op.h_in || 80}&quot;
            </text>
          </g>
        );
      })}
    </g>
  );
}
